import React from 'react';
import classNames from 'classnames';
import { IPrintGMDSSTableData, IPrintTableGMDSSLogEntry } from 'redux/app/vessel/inspector/types';

const renderActions = (entry: IPrintTableGMDSSLogEntry): React.ReactNode => {
    if (entry.isRed) {
        return (
            <span className="text-red-600 font-semibold">{entry.actions}</span>
        );
    }
    if (entry.hasRedText) {
        return (
            <>
                Printers checked for paper and power supply.{' '}
                <span className="text-red-600">All found Satisfactory.</span>
            </>
        );
    }
    return entry.actions;
};

interface ISampleEntryBaseTable {
    tableData: IPrintGMDSSTableData;
}

function SampleEntryBaseTable(props: ISampleEntryBaseTable) {
    const { tableData } = props;
    return (
        <table className="w-full border-collapse border-2 border-black text-xs">
            <thead>
                <tr>
                    <th className="border-2 border-black p-2 bg-white font-bold text-center w-[10%]">
                        DATE AND TIME
                        <br />
                        GMT
                    </th>
                    <th className="border-2 border-black p-2 bg-white font-bold text-center w-[8%]">
                        STATION
                        <br />
                        TO
                    </th>
                    <th className="border-2 border-black p-2 bg-white font-bold text-center w-[8%]">
                        STATION
                        <br />
                        FROM
                    </th>
                    <th className="border-2 border-black p-2 bg-white font-bold text-center w-[35%]">
                        OPERATORS ACTIONS OR REMARKS
                    </th>
                    <th className="border-2 border-black p-2 bg-white font-bold text-center w-[15%]">
                        FREQUENCY
                        <br />
                        CHANNEL OR
                        <br />
                        SATELLITE
                    </th>
                    <th className="border-2 border-black p-2 bg-white font-bold text-center w-[15%]">
                        OPERATOR'S <span className="text-red-600">&</span>
                        <br />
                        <span className="text-red-600">MASTER'S</span> NAME{' '}
                        <span className="text-red-600">&</span>
                        <br />
                        <span className="text-red-600">SIGN</span>
                    </th>
                </tr>
            </thead>
            <tbody>
                {tableData.categories.map((category, categoryIdx) => (
                    <React.Fragment key={`category-${categoryIdx}`}>
                        {category.categoryName ? (
                            <tr>
                                <td
                                    colSpan={6}
                                    className={`border-2 border-black p-0.5  font-bold`}
                                >
                                    <span className={category?.bgColor}>
                                        {category.categoryName}
                                    </span>
                                </td>
                            </tr>
                        ) : null}

                        {category.sections.map((section, sectionIdx) => (
                            <React.Fragment
                                key={`section-${categoryIdx}-${sectionIdx}`}
                            >
                                {section?.title ? (
                                    <tr>
                                        <td
                                            colSpan={6}
                                            className="border-2 border-black p-0.5 font-bold text-blue-700"
                                        >
                                            {section.title}
                                        </td>
                                    </tr>
                                ) : null}
                                {section.subtitle && (
                                    <tr>
                                        <td
                                            colSpan={6}
                                            className="border-2 border-black p-0.5 italic text-blue-600"
                                        >
                                            {section.subtitle}
                                        </td>
                                    </tr>
                                )}
                                {section.entries.map((entry, entryIdx) => (
                                    <tr
                                        key={`entry-${categoryIdx}-${sectionIdx}-${entryIdx}`}
                                    >
                                        <td className="border-2 border-black p-0.5 text-center whitespace-pre-line w-[10%]">
                                            {entry.dateTime}
                                        </td>
                                        <td className="border-2 border-black p-0.5 text-center w-[8%]">
                                            {entry.stationTo}
                                        </td>
                                        <td className="border-2 border-black p-0.5 text-center w-[8%]">
                                            {entry.stationFrom}
                                        </td>
                                        <td className="border-2 border-black p-0.5 w-[35%]">
                                            {renderActions(entry)}
                                        </td>
                                        <td className="border-2 border-black p-0.5 text-center whitespace-pre-line w-[15%]">
                                            {entry.frequency}
                                        </td>
                                        <td className="border-2 border-black p-0.5 text-center whitespace-pre-line w-[15%]">
                                            {entry.operator}
                                        </td>
                                    </tr>
                                ))}
                            </React.Fragment>
                        ))}
                        {category?.notes ? (
                            <tr>
                                <td
                                    colSpan={6}
                                    className={`border-2 border-black p-0.5  font-bold`}
                                >
                                    <ul>
                                        {category?.notes?.map((note, index) => {
                                            return (
                                                <li
                                                    className={classNames(
                                                        note?.style,
                                                        'text-xs text-blue-400'
                                                    )}
                                                >
                                                    <span className="mx-4">
                                                        {index + 1}.{' '}
                                                    </span>
                                                    <span> {note?.text}</span>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </td>
                            </tr>
                        ) : null}
                    </React.Fragment>
                ))}
            </tbody>
        </table>
    );
}

export default SampleEntryBaseTable;
